$(document).ready(function () {
    window["startTime"] = new Date();
    $('#top').on('click', confirmExtRef);
    $("a[href='#top']").click(function () {
        $("html, body").animate({scrollTop: 0}, "slow");
        return false;
    });
    if (!window['asExtRefWhitelist']) {
        window['asExtRefWhitelist'] = [];
    }
    $('.taglib-captcha .refresh a').on('click', function(event) {
        event.stopPropagation();
        var captcha = $(this).closest('.taglib-captcha');
        var img = captcha.find('img');
        var src = img.attr('src');
        var newSrc = src.replace(/t=\d+/, 't=' + new Date().getTime());
        img.attr('src', newSrc);
        return false;
    });
    hookinNavigation();
    if (checkConsent) {
        checkConsent();
    }
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            $('#navigation-container').collapse('hide')
        }
    });

    if (window.svg4everybody) {
		svg4everybody(
			{
				polyfill: true,
				validate: function (src, svg, use) {
					return !src || !src.startsWith('#');
				}
			}
		);
	}
});

window['vwas'] = {};
var isEN = Liferay.ThemeDisplay.getLanguageId().indexOf('en') >= 0;
vwas['title'] = isEN ? 'External link' : 'Externe Inhalte';
vwas['subheadline'] = isEN ? 'By using this link you are leaving the Autostadt GmbH web pages. The terms of use of the third-party website accessed via the link then apply.' : 'Wenn Sie auf diesen Link gehen, verlassen Sie die Seiten der Autostadt GmbH. Es gelten dann gegebenenfalls etwaige Nutzungsbedingungen des Dritten.';
vwas['confirmtext'] = isEN ? 'Autostadt GmbH has no control over the personal data collected, stored or processed by the third-party site. More details about such information may be found in the data protection statement of the service provider/operator of the third-party site.' : 'Die Autostadt GmbH hat keinen Einfluss darauf, welche Daten auf der von einem Dritten angebotenen Seite von Ihnen erhoben, gespeichert oder verarbeitet werden. Nähere Informationen hierzu können Sie gegebenenfalls in der Datenschutzerklärung des Anbieters der externen Webseite finden.';
vwas['cancel'] = isEN ? 'Cancel' : 'Abbrechen';
vwas['accept'] = isEN ? 'Accept' : 'Akzeptieren';

function closeBsModals() {
    $('.modal').modal('hide');
    $('.modal').remove();
}

function showBsModal(title, body, callback) {
    var modal = '<div class="modal" tabindex="0" aria-modal="true" role="dialog"><div class="modal-dialog modal-dialog-centered mw">';
    modal += '<div class="modal-content"><div class="modal-header"><div class="btn-toolbar-content btn-toolbar order-1"><button type="button" class="btn-toolbar-button btn-link btn-small close btn btn-default" onclick="closeBsModals()" aria-label="'+(isEN ? 'Close pop-up' : 'Hinweisfenster schließen')+'">×</button></div><div class="modal-title">' + title + '</div></div>';
    modal += '<div class="modal-body" style="max-height: 510px;">' + body + '</div>';
    modal += '<div class="modal-footer">';
    modal += '<button type="button" class="btn-small btn btn-default btn-outline-secondary" role="button" onclick="closeBsModals()">' + vwas.cancel + '</button>';
    modal += '<button type="button" class="btn-small btn btn-default btn-secondary proceed" role="button">'+vwas.accept+'</button>';
    modal += '</div></div></div></div>';

    closeBsModals();
    $(modal).appendTo('body');
    $('.modal').modal('show');
    $('.modal .proceed').on('click', function () {
        if (callback) {
            callback();
        }
        closeBsModals();
    });
}

function showPopupExtRef(targetURL) {
    showBsModal(vwas.title, '<div class="strong mb-2">' + vwas.subheadline + '</div><div>' + vwas.confirmtext + '</div>', function () {
        window.open(targetURL, '_blank')
    });
}

function hookinBC(formNode, namespace, beforeNode) {
    const ariaLabel = isEN ? 'Checkbox to check if the form is filled out by a human' : 'Checkbox zur Prüfung, ob das Formular von einem Menschen ausgefüllt wurde';
    const title = isEN ? 'I am a human' : 'Ich bin ein Mensch';
	$('<div class="bc"><button aria-checked="false" aria-label="'+ariaLabel+'" id="bcb" role="checkbox" type="button"></button><span><sup>*</sup> '+title+'</span></div>').insertBefore(beforeNode || formNode.find('.button-holder'));
	$('button#bcb').on('click', function () {
		const now = new Date();
        if (now - window["startTime"] > 3500 && !$('#bcauth').val()) {
            $(`<input id="${namespace}bcauth" type="hidden" name="${namespace}bcauth" value="asbc"/>`).appendTo(formNode);
            $("#bcb").addClass("valid").attr('aria-checked', 'true');
            $('div.bc').css('border-color', '');
        };
	});
}

function confirmExtRef(ev) {
    var link = ev.target;
    if (link.tagName !== 'A') {
        link = ev.target.parentNode;
    }
    if (link.tagName !== 'A') {
        const teaserElem = $(link).closest('.teaser')[0];
        if (teaserElem) {
            link = teaserElem.parentNode;
        }
    }
    if (link.tagName === 'A' && document.getElementsByTagName('body')[0].className.indexOf('has-edit-mode-menu') < 0) {
        var targetURL = link ? link.getAttribute("href") : link.currentTarget.attr('href');
        if (isExternalUrl(targetURL)) {
            ev.preventDefault();
            showPopupExtRef(targetURL);
        }
    }
    //return false;
}

function asUrlOpen(url) {
    if (document.getElementsByTagName('body')[0].className.indexOf("has-edit-mode-menu") === -1) {
        if (isExternalUrl(url)) {
            showPopupExtRef(url);
        } else {
            window.location.href = url;
        }
    }
    return false;
}

function isExternalUrl(url) {
    if (!url) {
        return false;
    }
    if (url.indexOf('http') < 0) {
        return false;
    }
    for (var i = 0; i < window['asExtRefWhitelist'].length; i++) {
        if (url.indexOf(window['asExtRefWhitelist'][i]) >= 0) {
            return false;
        }
    }
    return true;
}

// function to disable pinch-zoom and double-tap zoom
function disableZoom() {
    /*
    document.addEventListener('touchmove', preventZoom, {passive: false});
    document.addEventListener('gesturestart', preventZoom);
    */
    $('#top').addClass('no-scroll');
}

// function to activate pinch-zoom and double-tap zoom
function enableZoom() {
    /*
    document.removeEventListener('touchmove', preventZoom);
    document.removeEventListener('gesturestart', preventZoom);
    */
    $('#top').removeClass('no-scroll');
}

// prevent zoom on touch devices
function preventZoom(event) {
    console.log('prevent zoom');
    if (event.scale !== 1) {
        event.preventDefault();
    }
}

function hookinNavigation() {
/*
    $('.navbar-toggler').addClass('collapsed');

    $('#navigation-container').on('show.bs.collapse', function (event) {
        if (event.target.id === 'navigation-container') {
            //$('#navigation-container').addClass('show');
            if ($('.navigation-container').has('.navigation-menu-level-2 .collapse.width.show')) {
                $('.navigation-menu-level-2').has('.collapse.width.show').addClass('show');

                // highlighting workaround for firefox
                $('.navigation-menu-level-2').has('.collapse.width.show').parent().addClass('active');

                if ($('.navigation-menu-level-2').has('.navigation-menu-level-3 .collapse.width.show')) {
                    $('.navigation-menu-level-3').has('.collapse.width.show').parent().addClass('active');

                    if ($('.navigation-menu-level-3').has('.navigation-menu-level-4 .collapse.show')) {
                        $('.navigation-menu-level-4').has('.collapse.show').parent().addClass('active');
                    }
                }
            }
            disableZoom();
        }
    });
    */

    $('#navigation-container').on('show.bs.collapse', function (event) {
        if (event.target.id === 'navigation-container') {
            disableZoom();
        }
    });

    $('#navigation-container').on('hidden.bs.collapse', function (event) {
        if (event.target.id === 'navigation-container') {
            //$('#navigation-container').removeClass('show');
            enableZoom();
        }
    }); 


/*
    $('[id^=collapseNavLevel2]').on('show.bs.collapse', function (event) {
        if (event.target.id.startsWith('collapseNavLevel2')) {
            $('.navigation-menu-level-2:has(#' + event.target.id + ')').addClass('show');

            $('.navigation-menu-level-2:has(#' + event.target.id + ')').parent().addClass('active');

            if ($('.navigation-menu-level-2:has(#' + event.target.id + ')').has('.navigation-menu-level-3 .collapse.width.show')) {
                $('.navigation-menu-level-3').has('.collapse.width.show').addClass('show');
            }
        }
    })

    $('[id^=collapseNavLevel2]').on('hidden.bs.collapse', function (event) {
        if (event.target.id.startsWith('collapseNavLevel2')) {
            $('.navigation-menu-level-2:has(#' + event.target.id + ')').removeClass('show');

            $('.navigation-menu-level-2:has(#' + event.target.id + ')').parent().removeClass('active');

            $('.navigation-menu-level-2:has(#' + event.target.id + ')').find('.navigation-menu-level-3 .collapse.show').find('.navigation-menu-level-4 .collapse.show').collapse('hide');
            $('.navigation-menu-level-2:has(#' + event.target.id + ')').find('.navigation-menu-level-3 .collapse.show').collapse('hide');


            if ($('.navigation-menu-level-2:has(#' + event.target.id + ')').has('.navigation-menu-level-3 .collapse.width.show')) {
                $('.navigation-menu-level-3').has('.collapse.width.show').removeClass('show');
                $('.navigation-menu-level-3 .collapse.width.show').removeClass('show');
                $('.navigation-menu-level-4').has('.collapse.show').removeClass('show');
                $('.navigation-menu-level-4 .collapse.show').removeClass('show');
            }
        }
    })
    $('[id^=collapseNavLevel3]').on('show.bs.collapse', function (event) {
        if (event.target.id.startsWith('collapseNavLevel3')) {
            $('.navigation-menu-level-3:has(#' + event.target.id + ')').addClass('show');

            $('.navigation-menu-level-3:has(#' + event.target.id + ')').parent().addClass('active');

            if ($('.navigation-menu-level-3:has(#' + event.target.id + ')').has('.navigation-menu-level-4 .collapse.show')) {
                $('.navigation-menu-level-4').has('.collapse.width.show').addClass('show');
            }
        }
    })

    $('[id^=collapseNavLevel3]').on('hidden.bs.collapse', function (event) {
        if (event.target.id.startsWith('collapseNavLevel3')) {
            $('.navigation-menu-level-3:has(#' + event.target.id + ')').removeClass('show');
            $('.navigation-menu-level-3:has(#' + event.target.id + ')').parent().removeClass('active');
            $('.navigation-menu-level-3:has(#' + event.target.id + ')').find('.navigation-menu-level-4 .collapse.show').collapse('hide');
        }
    })

    $('[id^=collapseNavLevel4]').on('show.bs.collapse', function (event) {
        if (event.target.id.startsWith('collapseNavLevel4')) {
            $('.navigation-menu-level-4:has(#' + event.target.id + ')').addClass('show');
            $('.navigation-menu-level-4:has(#' + event.target.id + ')').parent().addClass('active');
        }
    })

    $('[id^=collapseNavLevel4]').on('hidden.bs.collapse', function (event) {
        if (event.target.id.startsWith('collapseNavLevel4')) {
            $('.navigation-menu-level-4:has(#' + event.target.id + ')').removeClass('show');
            $('.navigation-menu-level-4:has(#' + event.target.id + ')').parent().removeClass('active');
        }
    })
        */
}